// Rumus: Total EXP = 50 * (Level^2)
// Kebalikannya (Cari Level): Akar(EXP / 50)

export const hitungLevel = (totalExp) => {
  if (totalExp < 50) return 1; // Level minimal 1
  const rawLevel = Math.sqrt(totalExp / 50);
  return Math.floor(rawLevel); // Bulatkan ke bawah
};

export const infoNextLevel = (totalExp) => {
  const currentLevel = hitungLevel(totalExp);
  const nextLevel = currentLevel + 1;

  // Target EXP untuk naik ke level berikutnya
  const targetExp = 50 * (nextLevel * nextLevel);

  return {
    currentLevel,
    nextLevel,
    targetExp,
    progress: Math.min(100, (totalExp / targetExp) * 100), // Persentase bar
  };
};
